import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getReportPayrolls(params: any): AxiosPromise {
    return EndPointService.get('/payrolls/reports', { params });
}
function paidReportPayroll(payload: any): AxiosPromise {
    return EndPointService.post('/payrolls/reports/paid', payload);
}

function updateReportPayroll(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/payrolls/status/paid/${id}`, { ...payload });
}
function getReportPayroll(id: number | string): AxiosPromise {
    return EndPointService.get(`/reportPayrolls/${id}`);
}

function deleteReportPayroll(id: number | string): AxiosPromise {
    return EndPointService.delete(`/reportPayrolls/${id}`);
}

export default {
    getReportPayrolls,
    getReportPayroll,
    deleteReportPayroll,
    paidReportPayroll,
    updateReportPayroll,
};
